import { c as _c } from "react/compiler-runtime";
import { usePageFilters } from "@/components/providers/AppFilterProvider/AppFilterProvider";
import { getActiveFilterCount } from "../../utils";
import { FilterConfig } from "../../schemas";
export function useMobileFilterCategoryList(pageKey, filters) {
  const $ = _c(11);
  const {
    filters: pageFilters,
    clearAllFilters
  } = usePageFilters(pageKey);
  let t0;
  if ($[0] !== pageFilters) {
    t0 = getActiveFilterCount(pageFilters);
    $[0] = pageFilters;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const totalActiveFilters = t0;
  let t1;
  if ($[2] !== filters || $[3] !== pageFilters) {
    let t2;
    if ($[5] !== pageFilters) {
      t2 = filter => ({
        ...filter,
        activeCount: pageFilters[filter.id]?.values?.length ?? 0
      });
      $[5] = pageFilters;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = filters.map(t2);
    $[2] = filters;
    $[3] = pageFilters;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const filtersWithActiveCount = t1;
  let t2;
  if ($[7] !== clearAllFilters || $[8] !== filtersWithActiveCount || $[9] !== totalActiveFilters) {
    t2 = {
      totalActiveFilters,
      filtersWithActiveCount,
      clearAllFilters
    };
    $[7] = clearAllFilters;
    $[8] = filtersWithActiveCount;
    $[9] = totalActiveFilters;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}